"use client";

/**
 * Rich Text Renderer
 * Renders rich text component preview in the canvas with inline editing support
 */

import type React from "react";
import type { RichTextComponent } from "../../../_types";
import { InlineTipTapEdit } from "./_shared/InlineTipTapEdit";
import { SectionContainer } from "./_shared/SectionContainer";
import { PROSE_SECTION_TEXT_VARS } from "./_shared/prose-section-text";

interface RichTextRendererProps {
  component: RichTextComponent;
}

/**
 * Renders a rich text section preview
 */
export function RichTextRenderer({ component }: RichTextRendererProps): React.ReactElement {
  const { title, content } = component;

  return (
    <SectionContainer
      background={component.background}
      title={title || ""}
      componentId={component.id}
      titleFieldId="richtext-title"
    >
      <InlineTipTapEdit
        content={content || ""}
        className={`prose prose-base prose-gray max-w-none prose-a:text-[var(--lp-accent)] prose-a:underline ${PROSE_SECTION_TEXT_VARS}`}
        componentId={component.id}
        fieldId="richtext-content"
        field="content"
        placeholder="Click to add content..."
      />
    </SectionContainer>
  );
}
